<template>
  <WsRead
    :modelName="modelName"
    :id="$route.params.id"
    :localeMode="localeMode"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    titleKey="remark"
  >
  </WsRead>
</template>

<script>
import model from "@/models/sos_request";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    localeMode: true,
    fields: model.fields,
    alertTitle: "",
    alertDescription: "",
    btnText: "",
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          hideOnNull: false,
          floors: [
            {
              fields: [
                "user_payload",
                "factory",
                "contact_person",
                "contact_way",
                "tel",
                "email",
                "contact_for",
                "remark",
                "attaches",
                "assignee",
                "status",
                "status_remark",
              ],
            },
          ],
        },
      ],
      secondary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "建立資訊",
              fields: ["created_admin", "created_at"],
            },
          ],
        },
         {
          type: "infoCard",
          floors: [
            {
              title: "編輯資訊",
              fields: ["updated_admin", "updated_at", ],
            },
          ],
        },
      ],
    },
  }),
};
</script>